var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text control", attrs: { "data-field": _vm.externalKey } },
    [
      _vm.showLabel
        ? _c("label", { staticClass: "text__label" }, [
            _vm._v(
              "\n    " + _vm._s(_vm.label) + _vm._s(_vm.measureUnit) + "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            text__display: true,
            "text__display--disabled": _vm.isDisabled
          },
          on: {
            click: function($event) {
              return _vm.setInputStatus(true)
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.displayValue) + "\n  ")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isInputActive,
            expression: "isInputActive"
          }
        ],
        ref: "input",
        staticClass: "text__input control-box",
        attrs: { disabled: _vm.isDisabled, type: "text" },
        domProps: { value: _vm.value },
        on: {
          blur: function($event) {
            return _vm.setInputStatus(false)
          },
          keypress: _vm.keypressHandler,
          keyup: _vm.keyupHandler,
          change: _vm.changeHandler
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }